export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/theme/components/scorecard/MetricsLabels/index.js